<template>
  <v-dialog v-model="innerShowValue" scrollable persistent width="500">
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon color="white" class="mr-2">mdi-map-legend</v-icon>
        Pilih Lokasi
        <v-btn class="mt-n1" icon dark top right absolute @click="resetFormMap">
          <v-icon color="grey">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6">
        <gmap-map
          :center="center"
          :zoom="15"
          :clickable="true"
          @click="updatePlace"
          class="_maps"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
          }"
        >
          <gmap-marker
            :position="center"
            :draggable="true"
            @drag="updatePlace"
            @click="center = center"
          >
          </gmap-marker>
        </gmap-map>
      </v-card-text>
      <v-card-actions class="pb-6 px-6">
        <v-spacer></v-spacer>
        <v-btn
          small
          color="#fff"
          elevation="0"
          class="text-capitalize grey--text text--darken-1"
          @click="resetFormMap"
        >
          Batal
        </v-btn>
        <v-btn
          small
          light
          color="light-green"
          elevation="0"
          @click="saveFormMap"
          class="white--text text-capitalize"
        >
          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      center: {
        lat: -7.7161435,
        lng: 110.3266482
      },
      innerShowValue: false
    };
  },

  watch: {
    value(val) {
      this.innerShowValue = val;
    },

    innerShowValue(val) {
      this.$emit('input', val);
    }
  },

  methods: {
    updatePlace(location) {
      this.center = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
    },

    resetFormMap() {
      this.center = {
        lat: -7.7161435,
        lng: 110.3266482
      };
      this.innerShowValue = false;
    },

    saveFormMap() {
      this.$emit('save', {
        latitude: this.center.lat,
        longitude: this.center.lng
      });
      this.resetFormMap();
    }
  }
};
</script>
